import mod from "-!./footerbar.js?vue&type=script&lang=js&"; export default mod; export * from "-!./footerbar.js?vue&type=script&lang=js&"